import {CopilotChatStoreState} from "components/pages/document/components/editor/components/right_drawer/copilot_chat/state/useCopilotChatStore";

export function setIsFluxOrganizationMember(set: (fn: (state: CopilotChatStoreState) => void) => void) {
    return (isFluxOrganizationMember: boolean) => {
        set((draft) => {
            draft.isFluxOrganizationMember = isFluxOrganizationMember;
        });
    };
}
